var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.29 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f3e9d7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bootstrap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42.65,22.7c0-3.6-3.3-4.1-5.2-4.1h-6.2v8.5h5.2C39.15,27.2,42.65,26.4,42.65,22.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M68.35,21a41.77,41.77,0,0,1-1.3-13.2V7.6A7.49,7.49,0,0,0,59.65,0H15.45a7.48,7.48,0,0,0-7.1,7.8A41.77,41.77,0,0,1,7.05,21c-1.3,4.1-3.5,6.8-7,7.1v3.8c3.5.3,5.7,3,7,7.1a41.77,41.77,0,0,1,1.3,13.2v.2a7.41,7.41,0,0,0,7.3,7.6h44.2A7.48,7.48,0,0,0,67,52.2a41.44,41.44,0,0,1,1.3-13.1c1.3-4.1,3.5-6.8,7-7.1V28.2C71.75,27.8,69.65,25.1,68.35,21ZM38.65,46.5H25.05v-33h13.5c6,0,10.1,3.4,10.1,8.5a7.71,7.71,0,0,1-4.6,7,8,8,0,0,1,6.2,8C50.35,42.9,45.85,46.5,38.65,46.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.35,31.9h-6.2v9.5h6.5c4.3,0,6.5-1.6,6.5-4.8S41.85,31.9,37.35,31.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.b771fc479a99bb884df2d554640c2a38.svg";
export { ForwardRef as ReactComponent };